import { schSiteInfluence, schSiteRating, schSiteView } from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import { getAloftAreaJSONPropertyGridField } from '../../../components/PropertyGrid/fields/utils.tsx';
import { PropertyGridSectionProps } from '../../../components/PropertyGrid/types.ts';

export const FeatureGridSiteSection = (props: PropertyGridSectionProps) => (
  <PropertyGridSection
    {...props}
    title="Site"
    fields={[
      getAloftAreaJSONPropertyGridField('editableData.site.area', 'Site Size'),
      {
        fieldName: 'editableData.site.influence',
        label: 'Site Influence',
        options: toOpts(schSiteInfluence.options),
        autofillSubjectValue: true,
      },
      {
        fieldName: 'editableData.site.influenceRating',
        label: 'Site Influence Rating',
        options: toOpts(schSiteRating.options),
        autofillSubjectValue: true,
      },
      {
        fieldName: 'editableData.site.view',
        label: 'View',
        options: toOpts(schSiteView.options),
        autofillSubjectValue: true,
      },
      {
        fieldName: 'editableData.site.viewRating',
        label: 'View Rating',
        options: toOpts(schSiteRating.options),
        autofillSubjectValue: true,
      },
    ]}
  />
);
